export default "__VITE_ASSET__BrliLCVq__"